import { Trans } from "@lingui/react/macro";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import type { TimeOffScope } from "../hooks/timeOffForm";

/**
 * Two options, never three: a series never reaches into its own past, so "all"
 * could only mean "all future" and would surprise anyone editing an occurrence
 * months out (design decision 20).
 */
export function TimeOffScopeDialog({
  isOpen,
  isDelete,
  allowFollowing = true,
  onDismiss,
  onChoose,
}: {
  isOpen: boolean;
  isDelete: boolean;
  /**
   * False once the change moves the occurrence off its own day or onto someone
   * else: the series regenerates its dates from its rule and keeps its target,
   * so it can only be detached, and the endpoint refuses the alternative.
   */
  allowFollowing?: boolean;
  onDismiss: () => void;
  onChoose: (scope: TimeOffScope) => void;
}) {
  return (
    <Modal isOpen={isOpen} onOpenChange={onDismiss} size="sm">
      <ModalContent>
        <ModalHeader>
          {isDelete ? (
            <Trans>Brisanje ponavljajoče odsotnosti</Trans>
          ) : (
            <Trans>Urejanje ponavljajoče odsotnosti</Trans>
          )}
        </ModalHeader>
        <ModalBody>
          <p className="text-sm text-gray-500">
            {allowFollowing ? (
              <Trans>Na kaj naj se sprememba nanaša?</Trans>
            ) : (
              <Trans>
                Premik na drug dan ali na drugega zaposlenega velja samo za to
                odsotnost.
              </Trans>
            )}
          </p>
        </ModalBody>
        <ModalFooter className="flex-col gap-2">
          <Button
            fullWidth
            color="primary"
            type="button"
            onPress={() => onChoose("ONLY_THIS")}
          >
            <Trans>Samo to odsotnost</Trans>
          </Button>
          {allowFollowing && (
            <Button
              fullWidth
              variant="bordered"
              type="button"
              onPress={() => onChoose("THIS_AND_FOLLOWING")}
            >
              <Trans>To in vse naslednje</Trans>
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
